<template>
    <v-container fluid fill-height class="loginContainer">
        <v-row no-gutters class="fill-height">
            <v-col cols="6">
                <v-sheet
                    height="100%"
                    class="d-flex align-center justify-center welcomeSheet"
                >
                    <div class="d-flex welcomeSheetContent">
                        <v-img
                            :src="require('@/assets/logo_name.png')"
                            alt="Logo"
                            width="20vw"
                        ></v-img>
                        <!--<p class="text-h3 font-weight-black">
                            UNITED PETROLEUM <br />
                            TRANSPORT <span class="text-h5">LTD.</span>
                        </p>-->
                    </div>
                    <div class="corner-box top-right"></div>
                    <div class="corner-box bottom-right"></div>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6" align-self="center">
                <v-row justify="center">
                    <v-col cols="12" md="10" align-self="center">
                        <v-card tile elevation="0">
                            <v-card-title class="headline">
                                {{ getLoginTitle() }}
                            </v-card-title>
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                    @submit.prevent="handleLogin"
                                >
                                    <v-text-field
                                        v-model="username"
                                        label="User Name"
                                        type="text"
                                        autocomplete="username"
                                        required
                                        :disabled="loading"
                                        :rules="[rules.username]"
                                    ></v-text-field>

                                    <v-text-field
                                        v-model="password"
                                        label="Password"
                                        :type="
                                            showPassword ? 'text' : 'password'
                                        "
                                        autocomplete="current-password"
                                        required
                                        :disabled="loading"
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:append>
                                            <v-icon
                                                small
                                                @click="
                                                    showPassword = !showPassword
                                                "
                                                :color="
                                                    showPassword
                                                        ? 'primary'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    showPassword
                                                        ? 'mdi-eye'
                                                        : 'mdi-eye-off'
                                                }}
                                            </v-icon>
                                        </template>
                                    </v-text-field>

                                    <v-row class="d-flex justify-center">
                                        <v-col cols="6" class="d-flex justify-start">
                                            <v-checkbox
                                                v-model="remember"
                                                label="Remember session"
                                                :disabled="loading"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex justify-end align-center"
                                            v-if="getLoginTitle() == 'Staff Login'"
                                        >
                                            <a href="/customer/login" style="margin: 0;padding: 0;">Go to customer login</a>
                                        </v-col>
                                        <v-col v-else cols="6" class="d-flex justify-end align-center">
                                        </v-col>
                                    </v-row>
                                    
                                    <v-btn
                                        block
                                        color="primary"
                                        type="submit"
                                        :loading="loading"
                                    >
                                        Login
                                    </v-btn>
                                    <v-alert
                                        type="error"
                                        icon="mdi-alert"
                                        dense
                                        outlined
                                        dismissible
                                        class="mt-5"
                                        v-model="error.status"
                                    >
                                        {{ error.message }}
                                    </v-alert>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { validations } from '@/Utils/validation';
import { mapActions } from 'vuex';
export default {
    name: 'Login',
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = this.getLoginTitle();
            }
        }
    },
    data() {
        return {
            username: '',
            password: '',
            remember: true,
            valid: true,
            error: {
                message: '',
                status: false,
            },
            showPassword: false,
            loading: false,
            rules: validations,
        };
    },
    methods: {
        ...mapActions('auth', ['login']),
        async handleLogin() {
        console.log("logging in the user ");
            try {
                console.log('Route ', this.$route.path);
                let userType = this.$route.path == '/login' ? 'internal' : 
                    this.$route.path == '/customer/login' ? 'customer' : '';
                await this.login({
                    credentials: {
                        username: this.username,
                        password: this.password,
                        remember: this.remember
                    },
                    userType
                });
                // Redirect to dashboard or home page
                this.$router.push('/home');
            } catch (error) {
                // Handle login error (e.g., show error message)
                console.error('Login failed:', error);

                if (error.response.status === 403) {
                    this.error.message = 'Unauthorized user';
                } else if (error.response.status === 401) {
                    this.error.message = 'Incorrect credentials';
                }

                this.error.status = true;
            }
        },
        getLoginTitle() {
            return this.$route.path == '/login' ? 'Staff Login' : 
                this.$route.path == '/customer/login' ? 'Customer Login' : '';
        }
    }
};
</script>

<style scoped>
.welcomeSheet {
    background-color: #f5f5f5;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.welcomeSheetContent {
    text-align: center;
    color: #424242; /* Dark gray text color */
}

.welcomeSheetContent .v-img {
    margin: 0 auto 20px auto;
    width: 200px; /* Adjust the width as needed */
}

.welcomeSheet {
    background-size: cover;
    background-image: linear-gradient(to bottom, #ffffff60, #0704318e),
        url('../assets/cover.png');
}
</style>
